import { action } from 'satcheljs';
import Permission from 'owa-service/lib/contract/Permission';
import PermissionLevelType from 'owa-service/lib/contract/PermissionLevelType';

// The actions defined here can be used privately in this package, that's why the file name is internal actions

/**
 * Action that can be dispatched to show folder permissions dialog.
 * @param folderId Folder Id for which permissions dialog should be shown.
 * @param shouldShow Boolean to show or hide Folder Permissions dialog
 */
export const showHideFolderPermissionDialog = action(
    'SHOW_FOLDER_PERMISSIONS_DIALOG',
    (folderId: string, shouldShow: boolean) => ({ folderId, shouldShow })
);

/**
 * Action that can be dispatched to show/hide loader on top of folder permissions dialog.
 * @param showLoader A boolean which to set showLoader value.
 */
export const setFolderPermissionsLoader = action(
    'SET_FOLDER_PERMISSIONS_LOADER',
    (showLoader: boolean) => ({ showLoader })
);

/**
 * Action fired to update folder permission in UI store
 * @param permissions Array of permission defined on a folder
 */
export const updateFolderPermissionsInUIStore = action(
    'UPDATE_FOLDER_PERMISSIONS_IN_UI_STORE',
    (permissions: Permission[]) => ({ permissions })
);

/**
 * Action fired to select permission index from array of permissions in UI store
 * @param permissionIndex The index to set
 */
export const selectPermissionIndex = action(
    'SELECT_PERMISSION_INDEX',
    (permissionIndex: number) => ({ permissionIndex })
);

/**
 * Action fired to show/hide add user dialog.
 * @param shouldShow Boolean to set the showAddUserDialog flag.
 */
export const shouldShowAddUserDialog = action('SHOW_ADD_USER_DIALOG', (shouldShow: boolean) => ({
    shouldShow,
}));

/**
 * Action fired when a user is added from add user dialog.
 * @param primarySmtpAddress Primary email address of user.
 * @param displayName Added user's name.
 */
export const addPermissionUser = action(
    'ADD_PERMISSION_USER',
    (primarySmtpAddress: string, displayName: string) => ({
        primarySmtpAddress,
        displayName,
    })
);

/**
 * Action fired when selected user is deleted
 */
export const deletePermissionUser = action('DELETE_PERMISSION_USER');

/**
 * Action to change permission level for selected permission in UI Store.
 * @param permissionLevel Selected permission level.
 */
export const changePermissionLevel = action(
    'CHANGE_PERMISSION_LEVEL',
    (permissionLevel: PermissionLevelType) => ({ permissionLevel })
);

/**
 * Action to change permission property for selected permission in UI store.
 * @param propertyName Name of the property to be modified
 * @param value Value of the property
 */
export const changeFolderPermissionProperty = action(
    'CHANGE_PERMISSION_PROPERTY',
    (propertyName: string, value: string | boolean) => ({ propertyName, value })
);

/**
 * Action is fired, when user clicks 'Ok' button in folder permissions dialog.
 */
export const folderPermissionsDialogOkClick = action('FOLDER_PERMISSIONS_DIALOG_OK_CLICK');
